import Switch from "@mui/material/Switch";

import { GenericTableColumn } from "components/organisms/GenericTable/GenericTable.types";

export type EventConfigRow = {
    id: number;
    name: string;
    status: number;
    eventCount: number;
    code: string;
    event_id: number;
};

type CreateEventsConfigColumnsArgs = {
    language?: any;
    pendingEventIds: Record<string | number, boolean>;
    onToggle: (eventId: number) => void;
};

export const createEventsConfigColumns = ({
    language,
    pendingEventIds,
    onToggle,
}: CreateEventsConfigColumnsArgs): GenericTableColumn<EventConfigRow>[] => [
    {
        key: "name",
        header: language?.events_config?.event_name ?? "Event",
        label: language?.events_config?.event_name ?? "Event",
        width: 3,
        minWidth: 180,
        render: (row) => row.name,
    },
    {
        key: "status",
        header: language?.events_config?.status ?? "Status",
        label: language?.events_config?.status ?? "Status",
        fixedWidth: 120,
        render: (row) => (
            <Switch
                checked={row.status === 1}
                disabled={Boolean(pendingEventIds[row.event_id])}
                onClick={(event) => event.stopPropagation()}
                onChange={(event) => {
                    event.stopPropagation();
                    onToggle(row.event_id);
                }}
            />
        ),
    },
    {
        key: "eventCount",
        header: language?.events_config?.event_count ?? "Count",
        label: language?.events_config?.event_count ?? "Count",
        width: 1,
        render: (row) => row.eventCount,
    },
];
